export default __webpack_public_path__ + "static/construction-mobile-banner-6619a36a98dd2b7e08e198dcd37045b9.png";